<template>
  <span>
    <span v-if="buttonProp" @click="showTaskModal(task)" class="cursor-pointer">
        {{ buttonProp }}
    </span>
    <span v-else>
      <b-button class="mr-2"
                variant="success"
                @click="showTaskModal(task)"
                qid="delete-s-cancel-button"
      >
        <span v-if="task">
          {{ $t('tasks.open_button') }}
        </span>
        <span v-if="!task">
          {{ $t('tasks.open_first_task') }}
        </span>
      </b-button>
    </span>


    <!-- Task modal -->
    <b-modal
        ref="task-modal"
        @hide="hideTaskModal"
        size="xl"
        modal-class="bottom-left task-modal"
    >
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideTaskModal" class="btn btn-secondary cursor-pointer float-right">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center" v-if="selectedTask && selectedTask.id && selectedTask.model">
            {{ $t('tasks.values.' + $options.filters.slugify(selectedTask.title)) }}
            {{ $t('system.on') }}
            <span v-if="selectedTask.model.who_am_i === 'App\\System\\Models\\System'">
              {{ $t('system.the_system') }}
            </span>
            <span v-if="selectedTask.model.who_am_i === 'App\\Activity\\Models\\Activity'">
              {{ $t('system.the_activity') }}
            </span>
            <span v-if="selectedTask.model.who_am_i === 'App\\Process\\Models\\Process'">
              {{ $t('system.the_process') }}
            </span>
            <span v-if="selectedTask.model.who_am_i === 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty'">
              {{ $t('system.the_contract') }}
            </span>
            <span v-if="selectedTask.model.who_am_i === 'App\\Maintenance\\Policy\\Models\\Policy'">
              {{ $t('system.the_policy') }}
            </span>
            <span class="breadcrumb-item ml-2">
              <a @click="navigateToTask(selectedTask)" :class="{'not-clickable': !isOwner(selectedTask.model)}">
                <font-awesome-icon icon="desktop" class="mr-1" v-if="selectedTask.model.who_am_i === 'App\\System\\Models\\System'"/>
                <font-awesome-icon icon="cubes" class="mr-1" v-if="selectedTask.model.who_am_i === 'App\\Activity\\Models\\Activity'"/>
                <font-awesome-icon icon="cube" class="mr-1" v-if="selectedTask.model.who_am_i === 'App\\Process\\Models\\Process'"/>
                <font-awesome-icon icon="file-signature" class="mr-1" v-if="selectedTask.model.who_am_i === 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty'"/>
                <font-awesome-icon icon="file-invoice" class="mr-1" v-if="selectedTask.model.who_am_i === 'App\\Maintenance\\Policy\\Models\\Policy'"/>

                {{ selectedTask.model.name }}
              </a>
            </span>
            <span v-if="selectedTask.model.who_am_i === 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty'">
              {{ $t('system.with') }}
              <Avatar :object="selectedTask.model.vendors[0]" size="xs"></Avatar>
              <span class="ml-1">{{ selectedTask.model.vendors[0].name }}</span>
            </span>
          </h5>
          <div class="row mt-3 pt-4 pb-1 pl-5 pr-5" v-if="selectedTask && selectedTask.id">
            <div class="col-sm-6"
                 v-if="getGuide(selectedTask.code)"
            >
              <b-form-group>
                <div class="">
                  <span class="btn btn-secondary btn-xs float-right cursor-pointer" @click="openGuide()">
                    <font-awesome-icon icon="eye" />
                    {{ $t('administration.guide.modal.button') }}
                  </span>
                  <label data-qid="create-p-users-label">
                    {{ $t('system.help_center_label') }}
                  </label>
                  <div v-if="wpGuide && wpGuide.id" class="guide-content-container">
                    <p v-if="!showFullGuideDescription" v-html="wpGuide.excerpt.rendered"></p>
                    <p v-if="showFullGuideDescription" v-html="wpGuide.content.rendered"></p>

                    <div class="text-center mt-3" @click="showFullGuideDescription=!showFullGuideDescription">
                      <span class="cursor-pointer" v-if="!showFullGuideDescription">
                        <span class="mr-2">
                          {{ $t('system.view_more') }}
                        </span>
                        <font-awesome-icon icon="chevron-down"/>
                      </span>
                      <span class="cursor-pointer" v-if="showFullGuideDescription">
                        <span class="mr-2">
                          {{ $t('system.view_less') }}
                        </span>
                        <font-awesome-icon icon="chevron-up"/>
                      </span>
                    </div>
                  </div>
                </div>
              </b-form-group>
            </div>
            <div :class="{'col-sm-6': getGuide(selectedTask.code), 'col-sm-12': !getGuide(selectedTask.code)}">
              <b-form-group>
                <div class="" v-if="selectedTask.project">
                  <span class="btn btn-secondary btn-xs float-right cursor-pointer" @click="openWelcomePage()" v-if="welcomeGuide && welcomeGuide.id">
                    <font-awesome-icon icon="eye" />
                    {{ $t('system.welcome_page_button') }}
                  </span>
                  <label data-qid="create-p-users-label">
                    <font-awesome-icon icon="calendar-alt" class="mr-2"/>
                    {{ selectedTask.project.title }}
                  </label>
                  <div v-if="selectedTask.project.schedule_message && selectedTask.project.schedule_message.length > 300">
                    <p v-if="showFullProjectMessage" class="text-formatted">
                      {{ selectedTask.project.schedule_message }}
                    </p>
                    <p v-if="!showFullProjectMessage" class="text-formatted">
                      {{ selectedTask.project.schedule_message | truncate(300) }}
                    </p>
                    <div class="text-center mt-3" @click="showFullProjectMessage=!showFullProjectMessage">
                      <span class="cursor-pointer" v-if="!showFullProjectMessage">
                        <span class="mr-2">
                          {{ $t('system.view_more') }}
                        </span>
                        <font-awesome-icon icon="chevron-down"/>
                      </span>
                      <span class="cursor-pointer" v-if="showFullProjectMessage">
                        <span class="mr-2">
                          {{ $t('system.view_less') }}
                        </span>
                        <font-awesome-icon icon="chevron-up"/>
                      </span>
                    </div>
                  </div>
                  <p v-if="selectedTask.project.schedule_message && selectedTask.project.schedule_message.length <= 300"
                     class="text-formatted"
                  >
                    {{ selectedTask.project.schedule_message }}
                  </p>
                </div>
                <div class="mt-2 mb-1" v-if="selectedTask.project && selectedTask.project.media">
                  <p
                      v-for="(file, index) in selectedTask.project.media"
                      :key="'file' + index"
                  >
                    <span class="mr-3 float-right text-muted cursor-pointer"
                          @click="downloadMedia(file)"
                          data-qid="download-media"
                    >
                      <font-awesome-icon icon="cloud-download-alt" />
                    </span>
                    <a @click="downloadMedia(file)" data-qid="create-p-media-item">
                      {{ file.file_name }}
                    </a>
                  </p>
                </div>

                <div class="" v-if="selectedTask.project && selectedTask.project.links">
                  <p
                      v-for="(link, index) in selectedTask.project.links"
                      :key="'link-' + index"
                  >
                    <a :href="link.url" target="_blank" data-qid="create-p-link-item">
                      {{ link.name ? link.name : link.url }}
                    </a>
                  </p>
                </div>
              </b-form-group>
            </div>
          </div>
        </div>

      </template>

      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-p-error"
      >
        {{ error }}
      </b-alert>
      <b-form qid="create-p-form" v-if="selectedTask && selectedTask.model">
        <div class="form-container mt-0 mb-2">

          <div class="row mt-1">

            <!-- Tables container -->
            <div class="col-sm-12">

              <!-- Activities -->
              <div v-if="selectedTask && selectedTask.model && selectedTask.model.who_am_i === 'App\\Activity\\Models\\Activity'">
                <div v-if="selectedTask.code === 'update_basic_info'">
                  <BasicInfoBlockActivity
                      :object="selectedTask.model"
                      :showOnTask="true"
                      :submitForm="submitForm"
                      @reloadContent="updateTasks"/>
                </div>
                <div v-if="selectedTask.code === 'update_description'">
                  <DescriptionBlock
                      :object="selectedTask.model"
                      :showOnTask="true"
                      :submitForm="submitForm"/>
                </div>
                <div v-if="selectedTask.code === 'update_organization'">
                  <OrganizationsTable
                      :object="selectedTask.model"
                      :showOnTask="true"/>
                </div>
                <div v-if="selectedTask.code === 'update_policies_and_procedures'">
                  <PoliciesAndProceduresTable
                      :object="selectedTask.model"
                      :showOnTask="true"/>
                </div>
                <div v-if="selectedTask.code === 'update_mapping_description'">
                  <MappingDescriptionBlock
                      :object="selectedTask.model"
                      :showOnTask="true"
                      :submitForm="submitForm"/>
                </div>
                <div v-if="selectedTask.code === 'update_systems'">
                  <SystemTable
                      :object="selectedTask.model"
                      :showOnTask="true"/>
                </div>
                <div v-if="selectedTask.code === 'update_third_party_sources'">
                  <ThirdPartySourcesTable
                      :object="selectedTask.model"
                      :showOnTask="true"/>
                </div>
                <div v-if="selectedTask.code === 'update_third_party_receivers'">
                  <ThirdPartyReceiversTable
                      :object="selectedTask.model"
                      :showOnTask="true"/>
                </div>
                <div v-if="selectedTask.code === 'update_processing_role'">
                  <ProcessingRole
                      :object="selectedTask.model"
                      :showOnTask="true"/>
                </div>
                <div v-if="selectedTask.code === 'update_data_subject'">
                  <DataSubjectsTable
                      :object="selectedTask.model"
                      :showOnTask="true"/>
                </div>
                <div v-if="selectedTask.code === 'update_retention_rule'">
                  <RetentionRulesTable
                      :object="selectedTask.model"
                      :showOnTask="true"/>
                </div>
                <div v-if="selectedTask.code === 'update_integrity_check'">
                  <IntegrityCheck
                      :object="selectedTask.model"
                      :showOnTask="true"/>
                </div>
                <div v-if="selectedTask.code === 'update_processing_type'">
                  <ProcessingType
                      :object="selectedTask.model"
                      :showOnTask="true"/>
                </div>
                <div v-if="selectedTask.code === 'update_risk_scenarios'">
                  <RiskScenariosTable
                      :object="selectedTask.model"
                      :showOnTask="true"/>
                </div>
                <div v-if="selectedTask.code === 'update_measures'">
                  <ActivityMeasuresTable
                      :object="selectedTask.model"
                      :showOnTask="true"/>
                </div>
              </div>

              <!-- Systems -->
              <div v-if="selectedTask && selectedTask.model && selectedTask.model.who_am_i === 'App\\System\\Models\\System'">
                <div v-if="selectedTask.code === 'update_basic_info'">
                  <BasicInfoBlockSystem
                      :object="selectedTask.model"
                      :showOnTask="true"
                      :submitForm="submitForm"
                      @reloadContent="updateTasks"/>
                </div>
                <div v-if="selectedTask.code === 'update_description'">
                  <DescriptionBlockSystem
                      :object="selectedTask.model"
                      :showOnTask="true"
                      :submitForm="submitForm"/>
                </div>
                <div v-if="selectedTask.code === 'update_policies_and_procedures'">
                  <PoliciesAndProceduresTableSystem
                      :object="selectedTask.model"
                      :showOnTask="true"/>
                </div>
                <div v-if="selectedTask.code === 'update_third_parties'">
                  <ThirdPartiesTable
                      :object="selectedTask.model"
                      :showOnTask="true"/>
                </div>
                <div v-if="selectedTask.code === 'update_data_objects'">
                  <DataObjectsTable
                      :object="selectedTask.model"
                      :showOnTask="true"/>
                </div>
                <div v-if="selectedTask.code === 'update_access_control'">
                  <AccessControlTable
                      :system="selectedTask.model"
                      :showOnTask="true"/>
                </div>
                <div v-if="selectedTask.code === 'update_log_management'">
                  <LogManagementTable
                      :system="selectedTask.model"
                      :showOnTask="true"/>
                </div>
                <div v-if="selectedTask.code === 'update_network'">
                  <NetworkTable
                      :system="selectedTask.model"
                      :showOnTask="true"/>
                </div>
                <div v-if="selectedTask.code === 'update_data_discovery'">
                  <DataDiscoveryTable
                      :system="selectedTask.model"
                      :showOnTask="true"/>
                </div>
                <div v-if="selectedTask.code === 'update_risk_scenarios'">
                  <RiskScenariosTableSystem
                      :object="selectedTask.model"
                      :showOnTask="true"/>
                </div>
                <div v-if="selectedTask.code === 'update_measures'">
                  <SystemMeasuresTable
                      :object="selectedTask.model"
                      :showOnTask="true"/>
                </div>
              </div>

              <!-- Processes -->
              <div v-if="selectedTask && selectedTask.model && selectedTask.model.who_am_i === 'App\\Process\\Models\\Process'">
                <div v-if="selectedTask.code === 'update_basic_info'">
                  <BasicInfoBlockProcess
                      :object="selectedTask.model"
                      :showOnTask="true"
                      :submitForm="submitForm"
                      @reloadContent="updateTasks"/>
                </div>
                <div v-if="selectedTask.code === 'update_description'">
                  <DescriptionBlockProcess
                      :object="selectedTask.model"
                      :showOnTask="true"
                      :submitForm="submitForm"/>
                </div>
                <div v-if="selectedTask.code === 'update_purpose'">
                  <PurposeBlock
                      :object="selectedTask.model"
                      :showOnTask="true"
                      :submitForm="submitForm"/>
                </div>
                <div v-if="selectedTask.code === 'update_policies_and_procedures'">
                  <PoliciesAndProceduresTableProcess
                      :object="selectedTask.model"
                      :showOnTask="true"/>
                </div>
                <div v-if="selectedTask.code === 'update_legal_basis'">
                  <LegalBasisTable
                      :object="selectedTask.model"
                      :showOnTask="true"/>
                </div>
                <div v-if="selectedTask.code === 'update_information_obligation'">
                  <InformationObligationTable
                      :object="selectedTask.model"
                      :showOnTask="true"/>
                </div>
                <div v-if="selectedTask.code === 'update_risk_profile'">
                  <Riskprofile
                      :object="selectedTask.model"
                      :showOnTask="true"/>
                </div>
                <div v-if="selectedTask.code === 'update_loss_of_confidentiality'">
                  <Confidentiality
                      :object="selectedTask.model"
                      :showOnTask="true"/>
                </div>
                <div v-if="selectedTask.code === 'update_loss_of_integrity'">
                  <Integrity
                      :object="selectedTask.model"
                      :showOnTask="true"/>
                </div>
                <div v-if="selectedTask.code === 'update_loss_of_availability'">
                  <Availability
                      :object="selectedTask.model"
                      :showOnTask="true"/>
                </div>
                <div v-if="selectedTask.code === 'update_risk_scenarios'">
                  <RiskScenariosTableProcess
                      :object="selectedTask.model"
                      :showOnTask="true"/>
                </div>
              </div>

              <!-- Third parties -->
              <div v-if="selectedTask && selectedTask.model && selectedTask.model.who_am_i === 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty'">
                <div v-if="selectedTask.code === 'update_basic_info'">
                  <BasicInfoBlockTP
                      :object="selectedTask.model"
                      :showOnTask="true"
                      :submitForm="submitForm"
                      @reloadContent="updateTasks"/>
                </div>
                <div v-if="selectedTask.code === 'update_description'">
                  <DescriptionBlockThirdParty
                      :object="selectedTask.model"
                      :showOnTask="true"
                      :submitForm="submitForm"/>
                </div>
                <div v-if="selectedTask.code === 'update_risk_scenarios'">
                  <RiskScenariosTableThirdParty
                      :object="selectedTask.model"
                      :showOnTask="true"/>
                </div>
                <div v-if="selectedTask.code === 'update_documents'">
                  <DocumentsTableThirdParty
                      :object="selectedTask.model"
                      :showOnTask="true"/>
                </div>
                <div v-if="selectedTask.code === 'update_contacts'">
                  <ContactsTableThirdParty
                      :object="selectedTask.model"
                      :showOnTask="true"/>
                </div>
                <div v-if="selectedTask.code === 'update_measures'">
                  <MeasuresTableThirdParty
                      :object="selectedTask.model"
                      :showOnTask="true"/>
                </div>
                <div v-if="selectedTask.code === 'update_subdata_processors'">
                  <SubDataProcessors
                      :object="selectedTask.model"
                      :showOnTask="true"/>
                </div>
                <div v-if="selectedTask.code === 'update_data_processor_agreement'">
                  <DataProcessorAgreement
                      :object="selectedTask.model"
                      :showOnTask="true"/>
                </div>
              </div>

              <!-- Policies and procedures -->
              <div v-if="selectedTask && selectedTask.model && selectedTask.model.who_am_i === 'App\\Maintenance\\Policy\\Models\\Policy'">
                <div v-if="selectedTask.code === 'update_basic_info'">
                  <BasicInfoBlockPolicy
                      :object="selectedTask.model"
                      :showOnTask="true"
                      :submitForm="submitForm"
                      @reloadContent="updateTasks"/>
                </div>
                <div v-if="selectedTask.code === 'update_description'">
                  <DescriptionBlockPolicy
                      :object="selectedTask.model"
                      :showOnTask="true"
                      :submitForm="submitForm"/>
                </div>
                <div v-if="selectedTask.code === 'update_documents'">
                  <DocumentsTablePolicy
                      :object="selectedTask.model"
                      :showOnTask="true"/>
                </div>
              </div>

            </div>
          </div>
        </div>

      </b-form>

      <template #modal-footer="{ close }">
        <div class="" style="width: 100%;">
          <div class="task-modal-info" v-if="selectedTask && selectedTask.id">
            <div class="row">
              <div class="col text-center pt-3 pb-3" v-if="selectedTask.users">
                <div class="mb-3">
                  <strong>{{ $t('projects.create.task_assignees') }}</strong>
                </div>
                <span
                    class="mr-1 text-normal"
                    v-for="(user, index) in getReducedUsers(selectedTask.users)"
                    :key="'user-' + index"
                >
                  <span data-qid="profile-photo">
                    <Avatar :object="user" size="xs"></Avatar>
                  </span>
                </span>
                <span v-if="selectedTask.users.length > 3"
                      class="badge cursor-pointer"
                      @click="openUsersModal(selectedTask)"
                >
                  <font-awesome-icon icon="users"/>
                  + {{ selectedTask.users.length - 3 }}
                </span>
              </div>
              <div class="col text-center pt-3 pb-3">
                <div class="mb-3">
                  <strong>{{ $t('table.due_date') }}</strong>
                </div>
                <span class="text-normal" v-if="selectedTask.project">
                  <span v-if="getDifference(selectedTask.project.end_date) > 3">
                    <font-awesome-icon icon="exclamation-triangle" class="risk-1"/>
                    {{ $t('system.due_in') }}
                    {{ getDifference(selectedTask.project.end_date) }}
                    {{ $t('system.days') }}
                  </span>
                  <span v-if="getDifference(selectedTask.project.end_date) <= 3 && getDifference(selectedTask.project.end_date) >= 0">
                    <font-awesome-icon icon="exclamation-triangle" class="risk-6"/>
                    {{ $t('system.due_in') }}
                    {{ getDifference(selectedTask.project.end_date) }}
                    {{ $t('system.days') }}
                  </span>
                  <span v-if="getDifference(selectedTask.project.end_date) < 0">
                    <font-awesome-icon icon="exclamation-triangle" class="risk-12"/>
                    {{ Math.abs(getDifference(selectedTask.project.end_date)) }}
                    {{ $t('system.days') }}
                    {{ $t('system.overdue') }}
                  </span>
                </span>
              </div>
              <div class="col text-center pt-3 pb-3">
                <div class="mb-3">
                  <strong>{{ $t('system.task_status') }}</strong>
                </div>
                <span v-if="selectedTask.status === 'completed'" >
                  <font-awesome-icon icon="check-circle" class="icon-success"/>
                </span>
                <span v-if="selectedTask.status === 'pending'" class="pr-2">
                  <font-awesome-icon
                      icon="exclamation-triangle"
                      class="risk-6"
                  />
                </span>
                <span class="text-normal">
                  {{ $t('system.' + $options.filters.slugify(selectedTask.status)) }}
                </span>
              </div>
              <div class="col text-center pt-3 pb-3">
                <div class="mb-3">
                  <strong>{{ $t('table.project') }}</strong>
                </div>
                <span v-if="selectedTask.project">
                  <span v-if="isOwner(selectedTask.project)" class="text-success breadcrumb-item cursor-pointer" @click="navigateToProject(selectedTask)">
                    <font-awesome-icon icon="calendar-alt" class="mr-1"/>
                    {{ selectedTask.project.title }}
                  </span>
                  <span v-if="!isOwner(selectedTask.project)" class="text-success breadcrumb-item" style="pointer-events:none;">
                    <font-awesome-icon icon="calendar-alt" class="mr-1"/>
                    {{ selectedTask.project.title }}
                  </span>
                </span>
              </div>
              <div class="col text-center pt-3 pb-3">
                <div class="mb-3">
                  <strong>{{ $t('projects.create.owners_label') }}</strong>
                </div>
                <span v-if="selectedTask.project">
                  <span
                      class="mr-1 text-normal"
                      v-for="(user, index) in getReducedUsers(selectedTask.project.users)"
                      :key="'user-' + index"
                  >
                    <span data-qid="profile-photo">
                      <Avatar :object="user" size="xs"></Avatar>
                    </span>
                  </span>
                  <span v-if="selectedTask.project && selectedTask.project.users.length > 3"
                        class="badge cursor-pointer"
                        @click="openUsersModal(selectedTask.project)"
                  >
                    <font-awesome-icon icon="users"/>
                    + {{ selectedTask.project.users.length - 3 }}
                  </span>
                </span>
              </div>
            </div>
          </div>
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">
                <span>
                  <vm-progress
                      type="circle"
                      :percentage="project_progress"
                      style="vertical-align: middle;"
                      :width="50"
                      :stroke-width="2"
                      stroke-color="#00c29e"
                  >
                    {{project_progress}}%
                  </vm-progress>
                </span>
                <span class="btn btn-link cursor-pointer text-bold ml-3" @click="showListOfTasks()">
                  {{ $t('tasks.show_list_label') }}
                </span>
              </div>
              <div class="col-sm-6 text-right">
                <b-button class="ml-3 mt-2"
                          variant="success"
                          @click="completeTask()"
                          :disabled="loadingFullList || buttonDisabled || !taskList.length"
                          qid="create-p-cancel-button"
                >
                  {{ $t('tasks.modal.complete') }}
                </b-button>
                <b-button @click="nextTask()"
                          class="ml-3 mt-2"
                          variant="secondary"
                          :disabled="loadingFullList || buttonDisabled || (taskList && taskList.length === 1) || !taskList.length"
                          qid="create-p-submit-button"
                >
                  {{ $t('system.skip') }}
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </template>
    </b-modal>


    <b-modal
        ref="all-done"
        hide-footer
        @hide="hideDoneModal"
        size="lg"
        modal-class="all-done-modal"
    >
      <template #modal-header="{ close }">
        <div class="text-center pt-2 pb-2" style="width: 100%;">
          <span @click="hideDoneModal" class="btn btn-secondary btn-sm cursor-pointer float-right">
            <font-awesome-icon icon="times"/>
          </span>
          <h3>DONE!!!</h3>
        </div>
      </template>

      <img style="width: 100%" src="@/assets/allDoneGif.gif" alt="">

    </b-modal>


    <ConfirmRemoveAttachment
        :object="selectedFile"
        :show="showDeleteAttachmentModal"
        type="file"
        @closeConfirmModal="closeDeleteAttachmentModal"
    ></ConfirmRemoveAttachment>

    <ConfirmRemoveAttachment
        :object="selectedLink"
        :show="showDeleteLinkModal"
        type="link"
        @closeConfirmModal="closeDeleteLinkModal"
    ></ConfirmRemoveAttachment>

    <GuideViewModal
        :guide="selectedGuide"
        :showModal="viewGuideModal"
        @closeViewModal="closeViewGuideModal"
    ></GuideViewModal>

    <GuideWatchVideoModal
        :guide="selectedGuide"
        :showModal="viewWatchVideoModal"
        @closeWatchVideoModal="closeWatchVideoGuideModal"
    ></GuideWatchVideoModal>

    <ShowMoreModal
        :items="selectedItem.users"
        :show="showUsersModal"
        @closeViewModal="closeUsersModal"
        type="users"
    ></ShowMoreModal>

  </span>

</template>

<script>
import piincHttp from '@/util/configureAxios.js'
import {config} from '@/config.js';
import ConfirmRemoveAttachment from '@/components/ConfirmRemoveAttachment.vue';
import GuideViewModal from '@/components/guide/GuideViewModal.vue';
import GuideWatchVideoModal from '@/components/guide/GuideWatchVideoModal.vue';
import roleCheck from "@/util/ACL/roleCheck"
import Avatar from '@/components/Avatar.vue';
import ShowMoreModal from '@/components/ShowMoreModal.vue';


// Activity imports
import DataSubjectsTable from '@/views/Activities/DataSubjectsTable.vue';
import DescriptionBlock from '@/views/Activities/DescriptionBlock.vue';
import MappingDescriptionBlock from '@/views/Activities/MappingDescriptionBlock.vue';
import RetentionRulesTable from '@/views/Activities/RetentionRulesTable.vue';
import SystemTable from '@/views/Activities/SystemTable.vue';
import ThirdPartySourcesTable from '@/views/Activities/ThirdPartySourcesTable.vue';
import ThirdPartyReceiversTable from '@/views/Activities/ThirdPartyReceiversTable.vue';
import IntegrityCheck from '@/views/Activities/IntegrityCheck.vue';
import ProcessingType from '@/views/Activities/ProcessingType.vue';
import ProcessingRole from '@/views/Activities/ProcessingRole.vue';
import RiskScenariosTable from '@/views/Activities/RiskScenariosTable.vue';
import ActivityMeasuresTable from '@/views/Activities/MeasuresTable.vue';
import PoliciesAndProceduresTable from '@/views/Activities/PoliciesAndProceduresTable.vue';
import OrganizationsTable from '@/views/Activities/OrganizationsTable.vue';
import BasicInfoBlockActivity from '@/views/Activities/BasicInfoTaskBlock.vue';

// System imports
import PoliciesAndProceduresTableSystem from '@/views/Systems/PoliciesAndProceduresTable.vue';
import DescriptionBlockSystem from '@/views/Systems/DescriptionBlock.vue';
import ThirdPartiesTable from '@/views/Systems/ThirdPartiesTable.vue';
import DataObjectsTable from '@/views/Systems/DataObjectsTable.vue';
import DataDiscoveryTable from '@/views/Systems/DataDiscoveryTable.vue';
import AccessControlTable from '@/views/Systems/AccessControlTable.vue';
import NetworkTable from '@/views/Systems/NetworkTable.vue';
import LogManagementTable from '@/views/Systems/LogManagementTable.vue';
import RiskScenariosTableSystem from '@/views/Systems/RiskScenariosTable.vue';
import SystemMeasuresTable from '@/views/Systems/MeasuresTable.vue';
import BasicInfoBlockSystem from '@/views/Systems/BasicInfoTaskBlock.vue';

// Process imports
import DescriptionBlockProcess from '@/views/Processes/DescriptionBlock.vue';
import PurposeBlock from '@/views/Processes/PurposeBlock.vue';
import PoliciesAndProceduresTableProcess from '@/views/Processes/PoliciesAndProceduresTable.vue';
import LegalBasisTable from '@/views/Processes/LegalBasisTable.vue';
import InformationObligationTable from '@/views/Processes/InformationObligationTable.vue';
import Confidentiality from '@/views/Processes/Confidentiality.vue';
import Riskprofile from '@/views/Processes/Riskprofile.vue';
import Integrity from '@/views/Processes/Integrity.vue';
import Availability from '@/views/Processes/Availability.vue';
import RiskScenariosTableProcess from '@/views/Processes/RiskScenariosTable.vue';
import BasicInfoBlockProcess from '@/views/Processes/BasicInfoTaskBlock.vue';

// Third party imports
import RiskScenariosTableThirdParty from '@/views/ThirdParty/RiskScenariosTable.vue';
import BasicInfoBlockTP from '@/views/ThirdParty/BasicInfoTaskBlock.vue';
import DescriptionBlockThirdParty from '@/views/ThirdParty/DescriptionBlock.vue';
import DocumentsTableThirdParty from '@/views/ThirdParty/DocumentsTable.vue';
import ContactsTableThirdParty from '@/views/ThirdParty/ContactsTable.vue';
import MeasuresTableThirdParty from '@/views/ThirdParty/MeasuresTable.vue';
import SubDataProcessors from '@/views/ThirdParty/SubDataProcessors.vue';
import DataProcessorAgreement from '@/views/ThirdParty/DataProcessorAgreement.vue';

// Policy imports
import DescriptionBlockPolicy from '@/views/Policies/DescriptionBlock.vue';
import BasicInfoBlockPolicy from '@/views/Policies/BasicInfoTaskBlock.vue';
import DocumentsTablePolicy from '@/views/Policies/DocumentsTable.vue';


export default {
    name: 'UpdateTaskModal',
    data: function() {
      return {
        taskForm: {
          remarks: ''
        },
        selectedTask: [],
        taskList: [],
        selectedAnswer: [],
        allAnswers: [
          { name: this.$t('tasks.modal.pass'), value: 'pass' },
          { name: this.$t('tasks.modal.fail'), value: 'fail' }
        ],
        buttonDisabled: false,
        selectedFile: {},
        selectedLink: {},
        showDeleteAttachmentModal: false,
        showDeleteLinkModal: false,
        showInput: false,
        showSingleLinkLabel: true,
        inputLink: '',
        descriptionLength: config.descriptionLength,
        showFullProjectMessage: false,
        showFullGuideDescription: false,
        showFullGenericControlDescription: false,
        showFullGenericControlPassedDescription: false,
        showFullGenericControlFailedDescription: false,
        error: '',
        selectedGuide: {},
        viewGuideModal: false,
        viewWatchVideoModal: false,
        myGuides: [],
        submitForm: false,
        project_progress: 0,
        doNotMinimize: false,
        updatePageOnClose: false,
        taskCompleted: false,
        welcomeGuide: {},
        wpGuide: {},
        selectedItem: {},
        showUsersModal: false,
        loadingFullList: false
      }
    },
    props: {
      task: {},
      type: {},
      tasks: {},
      fromHomepage: {},
      activeGuide: {},
      buttonProp: ''
    },
    components: {
      ConfirmRemoveAttachment,
      DataSubjectsTable,
      RetentionRulesTable,
      SystemTable,
      ThirdPartySourcesTable,
      ThirdPartyReceiversTable,
      IntegrityCheck,
      ProcessingType,
      ProcessingRole,
      RiskScenariosTable,
      DataDiscoveryTable,
      AccessControlTable,
      NetworkTable,
      LogManagementTable,
      RiskScenariosTableSystem,
      Confidentiality,
      Riskprofile,
      Integrity,
      Availability,
      RiskScenariosTableProcess,
      PoliciesAndProceduresTable,
      OrganizationsTable,
      PoliciesAndProceduresTableSystem,
      ThirdPartiesTable,
      DataObjectsTable,
      DescriptionBlockSystem,
      DescriptionBlock,
      MappingDescriptionBlock,
      DescriptionBlockProcess,
      PurposeBlock,
      PoliciesAndProceduresTableProcess,
      LegalBasisTable,
      InformationObligationTable,
      BasicInfoBlockTP,
      BasicInfoBlockProcess,
      BasicInfoBlockSystem,
      BasicInfoBlockActivity,
      GuideViewModal,
      GuideWatchVideoModal,
      RiskScenariosTableThirdParty,
      SystemMeasuresTable,
      ActivityMeasuresTable,
      DescriptionBlockPolicy,
      BasicInfoBlockPolicy,
      DocumentsTablePolicy,
      DataProcessorAgreement,
      SubDataProcessors,
      MeasuresTableThirdParty,
      ContactsTableThirdParty,
      DocumentsTableThirdParty,
      DescriptionBlockThirdParty,
      Avatar,
      ShowMoreModal
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getUser() {
        return this.$store.state.user
      },
      getWordpressLink() {
        return this.$store.state.wordpressLink
      },
    },
    watch: {
      getClient: function () {

      }
    },
    methods: {
      openGuide() {
        if (this.wpGuide && this.wpGuide.link) {
          window.open(this.wpGuide.link, '_blank')
        }
      },
      getReducedUsers(users) {
        let reducedUsers = []
        if (users) {
          if (users.length > 3) {
            reducedUsers = _.cloneDeep(users);
            reducedUsers = reducedUsers.slice(0, 3);
          } else {
            reducedUsers = users;
          }
        }
        return reducedUsers;
      },
      getDifference(endDate) {
        let moment = require('moment');
        let currentDate = moment()
        endDate = moment(endDate);
        return endDate.diff(currentDate, 'days');
      },
      openUsersModal(object) {
        this.selectedItem = object
        this.showUsersModal = true
      },
      closeUsersModal() {
        this.selectedItem = {}
        this.showUsersModal = false
      },
      showTaskModal(object) {

        let self = this;
        let perPage = 100
        this.error = '';

        if (object != null) {

          this.selectedTask = object
          this.loadTaskById(this.selectedTask.id, true);
          this.loadGuides(this.selectedTask.code)
          if (this.tasks && this.tasks.id) {
            self.loadingFullList = true
            piincHttp.get('projects/' + this.tasks.slug + '/tasks/me/small', { params:
              {
                status: 'pending',
                per_page: perPage,
              }
            }).then(function(response) {
              self.taskList = response.data.items;
              self.loadingFullList = false
            }, function() {});
          }
        }

        if (object == null && this.tasks && this.tasks.length) {
          this.selectedTask = this.tasks[0]
          this.loadTaskById(this.selectedTask.id, true);
          this.loadGuides(this.selectedTask.code)
        }

        if (object == null && this.tasks && this.tasks.id) {
          self.loadingFullList = true
          piincHttp.get('projects/' + this.tasks.slug + '/tasks/me', { params:
            {
              status: 'pending',
              per_page: 1,
            }
          }).then(function(response) {
            self.selectedTask = response.data.items[0];
            self.loadTaskById(self.selectedTask.id, true);
            self.loadGuides(self.selectedTask.code)
            piincHttp.get('projects/' + self.tasks.slug + '/tasks/me/small', { params:
              {
                status: 'pending',
                per_page: perPage,
              }
            }).then(function(response) {
              self.taskList = response.data.items;
              self.loadingFullList = false
            }, function() {});
          }, function() {});

        }

        //this.populateForm()
        this.$refs['task-modal'].show()

        this.loadTaskGuide()
      },
      showListOfTasks() {
        this.hideTaskModal()
        this.$emit('showViewModal');
      },
      openWelcomePage() {
        this.showViewGuideModal(this.welcomeGuide)
      },
      updateTasks(model) {
        _.forEach(this.taskList, function (item) {
          if (item.model.id === model.id) {
            item.model = model;
          }
        })
        this.updatePageOnClose = true;
        this.submitForm = false;
      },
      navigateToTask(object) {
        if (this.isOwner(object.model)) {
          this.$store.commit('storeTaskToolbarState', true);
          this.$store.commit('storeActiveTask', object);
          if (object.model_type === 'App\\Activity\\Models\\Activity') {
            this.$router.push({ name: 'activities.view', params: { slug: object.model.slug }, query: { task: object.id }})
          }
          if (object.model_type === 'App\\Process\\Models\\Process') {
            this.$router.push({ name: 'processes.view', params: { slug: object.model.slug }, query: { task: object.id }})
          }
          if (object.model_type === 'App\\System\\Models\\System') {
            this.$router.push({ name: 'systems.view', params: { slug: object.model.slug, }, query: { task: object.id }})
          }
          if (object.model_type === 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty') {
            this.$router.push({ name: 'contracts.view', params: { slug: object.model.slug, }, query: { task: object.id }})
          }
          if (object.model_type === 'App\\Maintenance\\Policy\\Models\\Policy') {
            this.$router.push({ name: 'policies.view', params: { slug: object.model.slug, }, query: { task: object.id }})
          }
        }
      },
      isOwner(object) {
        let self = this;
        let allow = false;
        let existingUser = _.find(object.users, function(user) {
          return user.id === self.getUser.id
        });

        if (existingUser) {
          allow = true
        } else {
          if (roleCheck('Client admin') || roleCheck('Partition admin') || this.getUser.isAdmin) {
            allow = true
          }
        }

        return allow
      },
      minimizeTask() {
        var element = document.getElementsByClassName('modal');
        element[0].classList.add("bottom-left");
        // this.submitForm = true
        this.$store.commit('storeLastClosedTask', this.selectedTask);
      },
      hideTaskModal() {
        // Kept so the task can be opened again from the sidebar
        this.$store.commit('storeLastClosedTask', this.selectedTask);
        let self = this;
        this.error = '';
        this.saveTask();

        setTimeout(function(){
          self.$emit('reloadContent');
          self.selectedTask = {}
        }, 500);

        if (this.taskList.length && !this.doNotMinimize) {
          this.minimizeTask();
        }

        if (this.updatePageOnClose) {
          this.$store.commit('storeUpdatePage', true);
        }

        if (this.taskCompleted) {
          self.$store.commit('storeReloadTasks');
        }

        self.$store.commit('storeUpdateTasks', true);
        this.taskList = []

        this.$refs['task-modal'].hide()

      },
      populateForm() {
        let self = this;

        self.taskForm.remarks = self.selectedTask.remarks

        self.selectedAnswer = []
        if (self.selectedTask.response) {
          self.selectedAnswer = _.find(self.allAnswers, function(item) {
            if(item.value === self.selectedTask.response){
              return self.selectedTask.response;
            }
          });
        }
      },
      saveTask() {

      },
      showViewGuideModal(object) {
        this.selectedGuide = object
        this.viewGuideModal = true
      },
      closeViewGuideModal() {
        this.selectedGuide = ''
        this.viewGuideModal = false
      },
      closeWatchVideoGuideModal() {
        this.selectedGuide = ''
        this.viewWatchVideoModal = false
      },
      completeTask() {
        this.buttonDisabled = true;
        this.submitForm = true
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        this.error = ''

        piincHttp.put('tasks/' + this.selectedTask.id, {
          status: 'completed'
        }).then(function() {
          self.$toastr('success', self.$t('tasks.modal.success'))
          self.buttonDisabled = false;
          self.taskCompleted = true;
          self.submitForm = false;

          if (self.taskList.length > 1) {
            let index = _.findIndex(self.taskList, function(o) { return o.id === self.selectedTask.id })
            if (index < self.taskList.length - 1) {
              self.selectedTask = self.taskList[index + 1]
            } else {
              self.selectedTask = self.taskList[0]
            }
            self.taskList.splice(index, 1);
            self.loadTaskById(self.selectedTask.id);
          } else {
            var element = document.getElementsByClassName('task-modal');
            element[0].classList.add("hide-task-modal");
            self.$refs['all-done'].show()
          }
        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
          }
        })

      },
      hideDoneModal() {
        this.$refs['all-done'].hide()
        this.doNotMinimize = true
        this.$refs['task-modal'].hide()
        this.$emit('reloadContent');
        this.$store.commit('storeUpdatePage', true);
        this.$store.commit('storeTaskToolbarState', false);
        this.$store.commit('storeActiveTask', {});
      },
      previousTask() {
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        this.error = ''

        let index = _.findIndex(self.taskList, function(o) { return o.id === self.selectedTask.id })
        if (index > 0) {
          this.selectedTask = this.taskList[index - 1]
        } else {
          this.selectedTask = this.taskList[this.taskList.length - 1]
        }

        self.loadTaskById(this.selectedTask.id);

      },
      nextTask() {
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        this.error = ''

        let index = _.findIndex(self.taskList, function(o) { return o.id === self.selectedTask.id })
        if (index < this.taskList.length - 1) {
          this.selectedTask = this.taskList[index + 1]
        } else {
          this.selectedTask = this.taskList[0]
        }

        self.loadTaskById(self.selectedTask.id);

      },
      resetFile() {
        let imagefile = document.querySelector('#file');
        imagefile.value = '';
      },
      loadTaskById(id, ignorePopulate) {
        let self = this;
        piincHttp.get('tasks/' + id).then(function(response) {
          self.selectedTask = response.data;
          self.project_progress = self.selectedTask.project.user_progress.progress;
          self.loadGuides(self.selectedTask.code)
          if (!ignorePopulate) {
            self.populateForm()
          }
        }, function() {});
      },
      openDeleteAttachmentModal(object) {
        this.selectedFile = object
        this.showDeleteAttachmentModal = true
      },
      closeDeleteAttachmentModal () {
        this.selectedFile = {}
        this.showDeleteAttachmentModal = false;
        this.loadTaskById(this.selectedTask.id, true);
      },
      openDeleteLinkModal(object) {
        this.selectedLink = object
        this.showDeleteLinkModal = true
      },
      closeDeleteLinkModal () {
        this.selectedLink = {}
        this.showDeleteLinkModal = false;
        this.loadTaskById(this.selectedTask.id, true);
      },
      downloadMedia(object){
        piincHttp.get('documents/' + object.id + '/download', {
          responseType: 'blob',
          params:
            {
              client: this.getClient.slug,
              task: this.selectedTask.id
            }
        }).then(function(response) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.download = object.file_name;

          link.click();
          link.remove()
          window.URL.revokeObjectURL(url);
        }, function() {});
      },
      onFileChange(file) {
        let files = file.target.files;
        let self = this;
        let formData = new FormData();
        let sizeError = false;

        for (var i = 0; i < files.length; i++) {
          // Equal to 10 MB
          if (files[i].size > 10485760) {
            sizeError = true;
          }
          formData.append('document[]', files[i]);
        }

        formData.append("name", "documents");
        formData.append("model_type", this.selectedTask.who_am_i);
        formData.append("model_id", this.selectedTask.id);

        if (sizeError) {
          this.error = this.$t('system.file_size')
        } else {
          piincHttp.post('documents', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then(function() {
            self.error = ''
            self.loadTaskById(self.selectedTask.id, true);
          }, function(error) {
            self.error = error.data.message;
            if (error.data.errors['document.0']) {
              self.error += ' ' + error.data.errors['document.0'][0]
            }
          })
        }
      },
      navigateToProject(task) {
        this.$store.commit('storeTaskToolbarState', true);
        this.$store.commit('storeActiveTask', task);
        this.$router.push({ name: 'projects.view', params: { slug: task.project.slug }})
      },
      getGuide(code) {
        if (code === 'update_mapping_description') {
          code = 'update_data_mapping_description'
        }
        let existingGuide = {}
        if (this.selectedTask && this.selectedTask.model && this.selectedTask.model.who_am_i === 'App\\Process\\Models\\Process') {
          existingGuide = _.find(this.myGuides, function(object) {
            return object.scope === code && object.enabled
          });
        }
        if (this.selectedTask && this.selectedTask.model && this.selectedTask.model.who_am_i === 'App\\System\\Models\\System') {
          existingGuide = _.find(this.myGuides, function(object) {
            return object.scope === code && object.enabled
          });
        }
        if (this.selectedTask && this.selectedTask.model && this.selectedTask.model.who_am_i === 'App\\Activity\\Models\\Activity') {
          existingGuide = _.find(this.myGuides, function(object) {
            return object.scope === code && object.enabled
          });
        }
        if (this.selectedTask && this.selectedTask.model && this.selectedTask.model.who_am_i === 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty') {
          existingGuide = _.find(this.myGuides, function(object) {
            return object.scope === code && object.enabled
          });
        }
        if (this.selectedTask && this.selectedTask.model && this.selectedTask.model.who_am_i === 'App\\Maintenance\\Policy\\Models\\Policy') {
          existingGuide = _.find(this.myGuides, function(object) {
            return object.scope === code && object.enabled
          });
        }

        return existingGuide
      },
      loadTaskGuide() {
        // let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';
        let self = this;
        piincHttp.get('guides', { params:
          {
            per_page: 1,
            language: 'en',
            type: 'Task',
            scope: 'update_task',
            client: this.getClient.slug
          }
        }).then(function(response) {
          if (response.data.items.length) {
            self.welcomeGuide = response.data.items[0]
          }
        }, function() {});
      },
      loadGuides(code) {
        let self = this;
        this.myGuides = []
        // let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';

        let type = ''

        if (this.selectedTask && this.selectedTask.model && this.selectedTask.model.who_am_i === 'App\\Process\\Models\\Process') {
          type = 'Process'
        }
        if (this.selectedTask && this.selectedTask.model && this.selectedTask.model.who_am_i === 'App\\System\\Models\\System') {
          type = 'System'
        }
        if (this.selectedTask && this.selectedTask.model && this.selectedTask.model.who_am_i === 'App\\Activity\\Models\\Activity') {
          type = 'Activity'
        }
        if (this.selectedTask && this.selectedTask.model && this.selectedTask.model.who_am_i === 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty') {
          type = 'Third party'
        }
        if (this.selectedTask && this.selectedTask.model && this.selectedTask.model.who_am_i === 'App\\Maintenance\\Policy\\Models\\Policy') {
          type = 'Policy'
        }

        if (code === 'update_mapping_description') {
          code = 'update_data_mapping_description'
        }

        piincHttp.get('guides', { params:
          {
            per_page: 1,
            language: 'en',
            type: type,
            scope: code,
            client: this.getClient.slug
          }
        }).then(function(response) {
          if (response.data.items.length) {
            self.myGuides.push(response.data.items[0])
            piincHttp.get(self.getWordpressLink + response.data.items[0].external_id).then(function(response) {
              self.wpGuide = response.data
            }, function() {});
          }
        }, function() {});
      },
    },
    created () {

    }
  }
</script>
